import { ProductArrangementUpdateInput, ProductArrangementWithProductsFragmentFragment } from 'data/__generated__';

export type ProductArrangementProduct = Omit<
    ProductArrangementWithProductsFragmentFragment['productsWithStockMax'][number]['product'],
    '__typename'
>;

export type ProductArrangementProductWithStockMaxFormValues = Omit<
    ProductArrangementWithProductsFragmentFragment['productsWithStockMax'][number],
    'stockMax' | '__typename' | 'product'
> & { product: ProductArrangementProduct; stockMax: number | null };

export type ProductArrangementFormValues = Omit<
    ProductArrangementWithProductsFragmentFragment,
    'productsWithStockMax' | '__typename'
> & {
    productsWithStockMax: ProductArrangementProductWithStockMaxFormValues[];
};

export function mapProductArrangementToProductArrangementFormValues({
    productArrangement: { __typename, ...productArrangementValues },
}: {
    productArrangement: ProductArrangementWithProductsFragmentFragment;
}): ProductArrangementFormValues {
    return {
        ...productArrangementValues,
    };
}

export function mapProductArrangementFormValuesToProductArrangementUpdateInput({
    productArrangementFormValues,
}: {
    productArrangementFormValues: ProductArrangementFormValues;
}): ProductArrangementUpdateInput {
    return {
        _id: productArrangementFormValues._id,
        name: productArrangementFormValues.name,
        productIdsWithStockMax: productArrangementFormValues.productsWithStockMax
            .filter(({ stockMax }) => stockMax !== null)
            .map(({ product, stockMax }) => ({
                productId: product._id,
                stockMax: stockMax as number,
            })),
        reassortmentType: productArrangementFormValues.reassortmentType,
    };
}
